export default [
  {
    path: "/rfidlog",
    name: "RFIDLog",
    props: { homepage: true},
    //beforeEnter: routeGuard,
    component: () => import("../views/rfidlog.vue"),
  },
  {
    path: "/rfidleituras",
    name: "RFIDLeituras",
    props: { homepage: true},
    //beforeEnter: routeGuard,
    component: () => import("../views/Leituras.vue"),
  }
]